// @flow
import React from 'react';
import { escapeForUrl } from 'lib/common';
import { Link } from 'react-router-dom';
import './BrandTags.scss';

type Props = {
  tags: string[],
};

const BrandTags = ({ tags }: Props) => (
  <div className="BrandTags">
    {tags.map(t => (
      <Link to={`/tags/${escapeForUrl(t)}`} key={t}>
        {t}
      </Link>
    ))}
  </div>
);

export default BrandTags;



// WEBPACK FOOTER //
// ./src/components/brand/BrandTags/BrandTags.js